import React, { FC } from 'react';
import { css } from 'emotion';

import Title from '@vromo/ui/components/Title';
import Container from '@vromo/ui/components/Container';
import PageLoader from './PageLoader';


type PageProps = {
    isLoading?: boolean;
    title: string;
    TopRightPlaceholder?: React.FC
    /** left sidebar */
    SidebarPlaceholder?: React.FC
}

/** commonly used page, with two placeholders: top rigtht, left sidebard 
 * todo: allow two layouts: page or element grid ( campaigns page )
 * todo: allow extra placeholder as the teams page ?
*/
export const Page: FC<PageProps> = ({ isLoading = false, children, title, TopRightPlaceholder, SidebarPlaceholder }) => {

    return (
        <div style={{ position: 'relative' }}>
            <PageLoader loading={isLoading} />
            <div
                className={css`
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0px 16px;
                `}>
                <Title style={{ textTransform: 'capitalize' }}>{title}</Title>
                {TopRightPlaceholder && <TopRightPlaceholder />}
            </div>
            {
                SidebarPlaceholder &&
                <Container>
                    <div
                        className={css`
                        width: 100%;
                        overflow: auto;
                        margin-top: 15px;
                    `}>
                        <SidebarPlaceholder />
                    </div>
                </Container>
            }
            <Container>
                <div
                    className={css`
                        width: 100%;
                        overflow: auto;
                        margin-top: 15px;
                    `}>
                    {children}
                </div>
            </Container>
        </div>
    )
}